<!-- Wrapper esterno per l'intestazione e la colonna -->
<div class="bg-gray-100 shadow-md flex flex-col h-full bg-fixed">

  <!-- Intestazione sopra la colonna con bordo nero e padding ridotto -->
  <div class="intestazione sticky top-0 justify-between items-center p-2  border-2 border-x border-y border-gray-300"
       style="z-index: 2500"
       [ngClass]="{'bg-red-400': isHighlightRed, 'bg-white': !isHighlightRed}"
  > <!-- padding ridotto a p-2 -->
    <!-- Contenitore centrale per il titolo e il sottotitolo -->
    <div class="flex-grow text-center">
      <div class="p-2 text-lg font-bold">{{ titlePrestazione }}</div>
    </div>
    <!-- Pulsanti Apri e Chiudi -->
    <div class="flex justify-center space-x-4">
      <button class="btn-open" (click)="unblockAllSlots()">Apri</button>
      <button class="btn-close" (click)="blockAllSlots()">Chiudi</button>
      <button class="btn-advance" (click)="blockPeriodo()">Avanzate</button>
    </div>
  </div>

  <!-- Colonna con il riferimento #colonnaRef -->
  <div class="relative flex-grow flex flex-col border border-gray-300 h-[1700px]">
    <!-- Riga per ogni ora nell'intervallo -->
    <div *ngFor="let slot of slots"
         class="hour-line flex border-t border-gray-300 items-stretch"
         [ngClass]="{'bg-gray-200': (slot.defaultBlock || isBlocked(slot))}"
         [ngStyle]="{'height': 100 / slots.length + '%'}"
         (click)="onSlotClick(slot)"
    >
      <!-- Colonna per mostrare l'ora con bordo a destra tratteggiato -->
      <div class="w-1/6 text-center h-full border-r-2 border-dashed border-r-gray-300 text-gray-500">
        {{ slot.startTime }}
      </div>
      <div class="w-5/6 relative h-full">

      </div>
    </div>

    <!-- Indicatore del tempo che si muove nella colonna -->
    <div class="time-indicator absolute z-10" [ngStyle]="{'top': timePosition + 'px'}">
      <div class="dot bg-red-500 rounded-full w-3 h-3 absolute top-1/2 transform -translate-y-1/2"></div>
    </div>
  </div>
</div>
